import { createRedactor, GetDefaultRules } from '@nerdwallet/redact';

const defaultRules = GetDefaultRules();

// Removes anything with an 'offer' key from the redaction list
const ATTRIBUTES_TO_EXCLUDE_FROM_REDACTION = ['offer'];

const isSubstringIncluded = (string: string, list: string[]): boolean =>
  list.some((item) => string.includes(item));

const includePropertyRule = {
  name: 'include_property',
  apply: (
    input: string,
    replacement: string,
    objectKey?: string | undefined
  ) => {
    if (objectKey)
      if (
        isSubstringIncluded(
          objectKey.toLowerCase(),
          ATTRIBUTES_TO_EXCLUDE_FROM_REDACTION
        )
      ) {
        return input;
      }
    const rule = defaultRules.rules.find(
      (rule) => rule.name === 'include_property'
    );
    if (!rule) {
      return input;
    }
    // Falls back to the default redaction rule if the objectKey is not in
    // the exclusion list
    return rule.apply(input, replacement, objectKey);
  },
};

const propertyNameRule = {
  name: 'property_name',
  apply: (
    input: string,
    replacement: string,
    objectKey?: string | undefined
  ): string => {
    if (objectKey)
      if (
        ATTRIBUTES_TO_EXCLUDE_FROM_REDACTION.includes(objectKey.toLowerCase())
      ) {
        return input;
      }
    // Falls back to the default redaction rule if the objectKey is not in
    // the exclusion list
    const rule = defaultRules.rules.find(
      (rule) => rule.name === 'property_name'
    );
    if (!rule) {
      return input;
    }
    return rule.apply(input, replacement, objectKey);
  },
};

// override the default rules with the custom rules for redacting
const redactor = createRedactor({
  customRules: [includePropertyRule, propertyNameRule],
  disabledRules: [{ default: ['include_property', 'property_name'] }],
});

export default redactor;
